// Halls Gap / Grampians (Gariwerd) content for the GapGo guest landing page.
//
// Images are freely-licensed Wikimedia Commons photos, verified reachable, used
// here as PLACEHOLDERS so the redesign can be reviewed live. Swap these for the
// hotel's own or properly-licensed photography before production.

const C = 'https://upload.wikimedia.org/wikipedia/commons/thumb';

// Rotating hero banner — sweeping Grampians vistas.
export const HERO_SLIDES = [
  {
    id: 'pinnacle',
    image: `${C}/0/01/View_from_Pinnacle_Lookout%2C_Grampians_NP_20230215_1.jpg/960px-View_from_Pinnacle_Lookout%2C_Grampians_NP_20230215_1.jpg`,
    alt: 'View from the Pinnacle Lookout over the Grampians',
    position: 'center',
  },
  {
    id: 'boroka',
    image: `${C}/a/a6/View_over_Halls_Gap%2C_Grampians%2C_from_Boroka_Lookout.jpg/960px-View_over_Halls_Gap%2C_Grampians%2C_from_Boroka_Lookout.jpg`,
    alt: 'View over Halls Gap township from Boroka Lookout',
    position: 'center',
  },
  {
    id: 'reed',
    image: `${C}/1/1e/Reed_lookout_Grampians.jpg/960px-Reed_lookout_Grampians.jpg`,
    alt: 'Reed Lookout at golden hour, Grampians',
    position: 'center',
  },
];

// "Discover Halls Gap" strip — famous spots to fall in love with the place.
// `map` is the place query used to open Google / Apple maps for that spot.
export const DISCOVER = [
  {
    id: 'pinnacle',
    name: 'The Pinnacle',
    tag: 'Halls Gap’s iconic clifftop lookout',
    emoji: '⛰️',
    map: 'The Pinnacle Lookout, Grampians National Park, Halls Gap VIC',
    image: `${C}/b/b2/The_Pinnacle_%2817010080777%29.jpg/960px-The_Pinnacle_%2817010080777%29.jpg`,
  },
  {
    id: 'mackenzie',
    name: 'MacKenzie Falls',
    tag: 'The Grampians’ mightiest waterfall',
    emoji: '💧',
    map: 'MacKenzie Falls, Grampians National Park VIC',
    image: `${C}/d/dd/MacKenzie_Falls_at_the_Grampians_%28500746318%29.jpg/960px-MacKenzie_Falls_at_the_Grampians_%28500746318%29.jpg`,
  },
  {
    id: 'boroka',
    name: 'Boroka Lookout',
    tag: 'Sunrise views over the valley',
    emoji: '🌄',
    map: 'Boroka Lookout, Grampians VIC',
    image: `${C}/f/f7/Just_before_sunrise_at_boroka_lookout.jpg/960px-Just_before_sunrise_at_boroka_lookout.jpg`,
  },
  {
    id: 'balconies',
    name: 'The Balconies',
    tag: 'Dramatic rock ledges at Reed Lookout',
    emoji: '🪨',
    map: 'The Balconies, Reed Lookout, Grampians VIC',
    image: `${C}/c/c8/The_Balconies_at_the_Grampians_%28500810149%29.jpg/960px-The_Balconies_at_the_Grampians_%28500810149%29.jpg`,
  },
  {
    id: 'kangaroos',
    name: 'Kangaroos in Town',
    tag: 'Wild roos graze on the rec reserve',
    emoji: '🦘',
    map: 'Halls Gap Recreation Reserve, Halls Gap VIC',
    image: `${C}/8/8f/Eastern_grey_kangaroo_-_Halls_Gap%2C_Victoria%2C_Australia_%284843639210%29.jpg/960px-Eastern_grey_kangaroo_-_Halls_Gap%2C_Victoria%2C_Australia_%284843639210%29.jpg`,
  },
  {
    id: 'zoo',
    name: 'Halls Gap Zoo',
    tag: 'Victoria’s largest regional zoo',
    emoji: '🦒',
    map: 'Halls Gap Zoo, Halls Gap VIC',
    image: `${C}/b/bd/Entrance_to_the_Halls_Gap_Zoo.jpg/960px-Entrance_to_the_Halls_Gap_Zoo.jpg`,
  },
];
